<template>
  <div class="flex flex-col w-full h-full">
   <iframe :src="url" width="100%" height="100%"></iframe>
   <!-- <div class="flex-end flex flex-row items-center justify-center pt-[15px] pb-[20px] shadow-md border-t border-solid border-[#e4e6e9]">
    <el-button type="success" @click="close()">关闭</el-button>
  </div> -->
  </div>
</template>

<script>
export default {
  name:"FrameSealPsnPage",
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.url = this.$route.query.url || "";
  },
}
</script>
<style scoped>
/deep/ .el-button {
  padding-left: 46px;
  padding-right: 46px;
}
</style>